import { FolderPageModule } from './folder/folder.module';


import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule, Storage } from '@ionic/storage-angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './modules/app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import { MatDialogModule } from '@angular/material/dialog';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';
import { TOKEN_KEY_CUSTOMER, TOKEN_KEY_USER } from './services/auth.service';
import { httpInterceptorProviders } from './http-interceptors';
import { LoginPageModule } from './pages/login/login.module';
import { LoginUserPageModule } from './pages/login-user/login-user.module';
import { SwiperModule } from 'swiper/angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function jwtOptionsFactory(storage) {
  return {
    tokenGetter: (request) => {
      console.log('TOKEN GETTER REQUEST', request);
      let token;
      if (window.location !== window.parent.location) {
        token = storage.get(TOKEN_KEY_CUSTOMER);
      } else {
        token = storage.get(TOKEN_KEY_USER);
      }

      return token;
    },
    allowedDomains: [ 'meinetermine.eu', environment.domain ]
  };
}

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [BrowserModule,
    IonicModule.forRoot({ mode: 'ios' }),
    IonicStorageModule.forRoot(),
    HttpClientModule,
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory,
        deps: [Storage]
      }
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    AppRoutingModule,
    BrowserAnimationsModule,
    //MatDialogModule,
    LoginPageModule,
    FolderPageModule,
    LoginUserPageModule,
    SwiperModule,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    httpInterceptorProviders
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
